"use strict";

var react = require("react"),
  reactRouterDom = require("react-router-dom");
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var o = 0; o < t.length; o++) {
    var r = t[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function _createClass(e, t, o) {
  return t && _defineProperties(e.prototype, t), o && _defineProperties(e, o), e;
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}
function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}
var getScrollPage = function () {
    var e = 0;
    return document.documentElement && null !== document.documentElement && (e = document.documentElement.scrollTop), window.pageYOffset || e;
  },
  getScrollElement = function (e) {
    var t = 0,
      o = document.getElementById(e);
    return null !== o && (t = o.scrollTop), t;
  },
  scrollTo = function () {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0;
    return window.requestAnimationFrame(function () {
      window.scrollTo(0, e);
    });
  },
  scrollToElement = function () {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0,
      t = 1 < arguments.length ? arguments[1] : void 0,
      o = document.getElementById(t);
    o && (o.scrollTop = e);
  },
  isBrowser = function () {
    return "undefined" != typeof window;
  },
  ScrollMemory = function (e) {
    function o(e) {
      var t;
      return _classCallCheck(this, o), (t = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, e))).detectPop = t.detectPop.bind(_assertThisInitialized(_assertThisInitialized(t))), t.url = new Map(), t;
    }
    return _inherits(o, react.Component), _createClass(o, [{
      key: "componentDidMount",
      value: function () {
        window.addEventListener("popstate", this.detectPop);
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        window.removeEventListener("popstate", this.detectPop);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function (e) {
        if (!isBrowser()) return !1;
        var t = this.props.location,
          o = e.location,
          r = t.key || "enter",
          n = (o.pathname !== t.pathname || o.search !== t.search) && "" === o.hash,
          i = this.props.elementID ? getScrollElement(this.props.elementID) : getScrollPage();
        return n && (this.props.elementID ? scrollToElement(0, this.props.elementID) : scrollTo(0), this.url.set(r, i)), !1;
      }
    }, {
      key: "detectPop",
      value: function (e) {
        if (isBrowser()) {
          var t = e.state,
            o = t && t.key ? t.key : "enter",
            r = this.url.get(o);
          r && (this.props.elementID ? scrollToElement(r, this.props.elementID) : scrollTo(r));
        }
      }
    }, {
      key: "render",
      value: function () {
        return null;
      }
    }]), o;
  }(),
  ScrollMemory$1 = reactRouterDom.withRouter(ScrollMemory);
module.exports = ScrollMemory$1;